module.exports = {
          srcSet: __webpack_public_path__ + "9834d761957b4f266acadb2e747f8680-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "9834d761957b4f266acadb2e747f8680-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "9834d761957b4f266acadb2e747f8680-24.png",
          toString:function(){return __webpack_public_path__ + "9834d761957b4f266acadb2e747f8680-24.png"},
          
          width: 24,
          height: 24
        }